<template lang="pug">
    #products-list
        model-data-table(
            remind-key='wh-product-list'
            loading-text="Cargando productos..."
            no-data-text="Sin productos."
            ref="table"
            v-bind="tableProps"
            @detail="submitShow"
            @remove="submitRemove"
            :no-detail="!$can('VIEW_DETAIL_COMMISSION')"
            :no-remove="!$can('DELETE_COMMISSION')"
            )
            template(slot="actions" slot-scope="props")
                v-tooltip(bottom)
                    v-btn(
                        color='amber darken-2'
                        flat
                        icon
                        @click='showDialogDiscount(props.item)'
                        slot="activator"
                        )
                        v-icon style
                    span Descuentos Cantidad
        v-dialog(v-model='dialogWholeDiscount' fullscreen hide-overlay transition="dialog-bottom-transition")
            v-toolbar(dark='' color='primary' )
                v-toolbar-title.white--text DESCUENTOS POR TRAMO - {{productSelected.name}}
                v-spacer
                v-btn(icon  @click.stop='dialogCloseWholeDiscount')
                    v-icon close
            v-card
                v-card-text
                    whole-sale-discount(:product="productSelected" @update_table="updateTableList" ref="discount")
                v-card-actions
</template>

<script>
//
import { mapActions, mapState } from 'vuex'
//
import { ModelDataTable } from '@/components/reusable_components/next'
import ItemDTService from '@/services/api/item/ItemDTService'
import ItemService from '@/services/api/item/ItemService'
import SaleUtils from '@/services/SaleUtils'
//
import ProviderService from '@/services/api/provider'
import WarehouseService from '@/services/api/warehouse'
import FamilyService from '@/services/api/family/FamilyServices'
import SubfamilyService from '@/services/api/subfamily/SubfamilyService'
import TagService from '@/services/api/tag/TagServices'
//
import MdlProduct from '../../models/Warehouse/WhProduct'
import ItemsFilters from './filters'
import ItemsHeaders from './headers'
//

import WholeSaleDiscount from './WholeSaleDiscount/WholeSaleDiscount'
//
export default {
    name: 'item-list',
    components: {
        'model-data-table': ModelDataTable,
        'whole-sale-discount': WholeSaleDiscount,
    },
    computed: {
        /**
         *
         */
        ...mapState('SnackbarModalModule', {
            responseConfirm: 'responseConfirm',
        }),
        /*  */
        ...mapState('WholesaleDiscountModule', {
            arrayDiscounts: 'arrayDiscounts',
            id: 'id',
            globalPercentageDiscount: 'globalPercentageDiscount',
        }),
        /*
         */
        ...mapState('AuthModule', ['user']),
        /**
         *
         */
        currentBranchOfficeId() {
            return 2
            //return this.currentUser ? this.currentUser.hr_employee.g_branch_office : 1
        },

        /**
         *
         */
        currentUser() {
            return this.$store.state.AuthModule.user
        },

        /**
         *
         */
        tableProps() {
            return {
                filters: this.filters,
                headers: this.headers,
                paramFilter: {
                    type: 'item',
                },
                mapper: row => {
                    row.branchOfficeId = this.currentUser.hr_employee.g_branch_office_id
                    return row.reset()
                },
                service: MdlProduct,
            }
        },
    },
    data() {
        return {
            // service: ItemDTService,
            filters: ItemsFilters,
            headers: ItemsHeaders,
            selectedId: null,
            dialogWholeDiscount: false,
            officeList: [],
            branchSelected: 1,
            productSelected: {
                name: '',
            },
        }
    },
    methods: {
        /**
         *
         */
        ...mapActions('MenuesModule', {
            setTitleTopBar: 'setTitleTopBar',
        }),

        /**
         *
         */
        ...mapActions('SnackbarModalModule', {
            initSnackbar: 'initSnackbar',
            hideSnack: 'hideSnack',
            resetSnackbarState: 'resetSnackbarState',
            setMessageConfirmSnack: 'setMessageConfirmSnack',
        }),

        /**
         *
         */
        computedCostPrice(item) {
            //
            const branch_office = item.branch_offices.find(
                this.findBranchOffice
            )
            //
            return branch_office ? branch_office.cost_price : 0
        },

        /**
         *
         */
        computedCriticalStock(item) {
            //
            const branch_office = item.branch_offices.find(
                this.findBranchOffice
            )
            //
            return branch_office ? branch_office.critical_stock : 0
        },

        /**
         *
         */
        computedGainMargin(item) {
            //
            const branch_office = item.branch_offices.find(
                    this.findBranchOffice
                ),
                sale_price = item.sale_prices.find(this.findSalePrice)
            //
            return branch_office && sale_price
                ? SaleUtils.getMargin(
                      sale_price.sale_price,
                      branch_office.cost_price
                  ) + ' %'
                : 0
        },

        /**
         *
         */
        computedSalePrice(item) {
            //
            const sale_price = item.sale_prices.find(this.findSalePrice)
            //
            return sale_price ? sale_price.sale_price : 0
        },

        /**
         *
         */
        findBranchOffice(branch_office) {
            return (
                this.currentBranchOfficeId === branch_office.g_branch_office_id
            )
        },

        /**
         *
         */
        findSalePrice(sale_price) {
            return this.currentBranchOfficeId === sale_price.branch_office_id
        },

        /**
         *
         */
        responseRemove(response) {
            switch (response.status) {
                case 200:
                    this.resetSnackbarState()
                    this.showSnackbar(
                        'success',
                        'Éxito.',
                        'Producto eliminado.'
                    )
                    this.$refs.table.checkAndFetch()
                    break
                default:
                    this.resetSnackbarState()
                    this.showSnackbar('error', 'Error.', response.message)
                    break
            }
        },

        /**
         *
         */
        showSnackbar(type, title, message) {
            this.initSnackbar(this.fillSnack(type, title, message))
        },

        /**
         *
         */
        submitCreate() {
            this.$router.push({ name: 'products_create' })
        },

        /**
         *
         */
        submitRemove(event) {
            //
            this.resetSnackbarState()
            this.setMessageConfirmSnack('eliminar item')
            this.showSnackbar(
                'warning',
                '¿Deseas eliminar el item?',
                'Una vez eliminado no se puede vender el producto.'
            )
            //
            this.selectedId = event.item.id
        },

        /**
         *
         */
        submitShow(event) {
            this.$router.push({
                name: 'products_show',
                params: { id: event.item.id },
            })
        },
        /*
         */
        showDialogDiscount(event) {
            this.productSelected = event
            this.dialogWholeDiscount = true
        },
        /*
         */
        updateTableList() {
            //console.log('akii para update')
            this.$refs.table.refresh().then(r => {
                r.forEach(row => {
                    if (row.id === this.productSelected.id) {
                        this.productSelected = row
                    }
                })
            })

            //console.log(this.productSelected,'product select')
            //this.dialogWholeDiscount = false
        },
        /*
         */
        dialogCloseWholeDiscount() {
            this.dialogWholeDiscount = false
            this.$refs.discount.$refs.formTable.$refs.fieldset.$refs.whole_sale_selected[0].selected = []
            //this.$refs.discount.$refs.formTable.$refs.selected = []
            this.$refs.discount.$refs.form.$refs.form.resetValidation()
        },
    },
    beforeMount() {
        this.setTitleTopBar('Productos')
        this.$setItemsTopBar([
            {
                text: 'crear producto',
                icon: 'add',
                can: 'CREATE_PRODUCT_ITEM',
                action: this.submitCreate,
            },
        ])
    },
    watch: {
        /**
         *
         */
        async responseConfirm(value) {
            switch (value) {
                case 'eliminar item':
                    this.responseRemove(
                        await ItemService.remove(this.selectedId)
                    )
                    break
            }
        },
    },
    beforeRouteEnter(to, from, next) {
        next(ctx => {
            if (!ctx.$can('VIEW_ALL_PRODUCT_ITEM')) ctx.$router.push('/')
        })
    },
}
</script>
